export enum CampaignsAnalytics {
  INDEX = '/campaigns/analytics',
  HISTORY = '/campaigns/analytics-history',
  DETAILS = '/campaigns/analytics-details',
  STATS = '/campaigns/analytics-stats',
}
